import dataAPI from "./api";
import * as subpub from "../utils/subpub";

/**
 * 从服务器检索数据
 *
 * @export
 * @param {*} settings
 * @returns Promise 
 */
export function fetch(settings: any) {
  return new Promise((resolve, reject) => {
    subpub.emit('loading', true);
    $.ajax($.extend({
      dataType: "jsonp",
      timeout: 10000,
      type: "get",
      success(res: any) {
        subpub.emit('loading', false);
        resolve(res);
      },
      error(res: any) {
        subpub.emit('loading', false);
        reject({ errmsg: '您的网络异常，请稍后重试！' });
      },
    }, settings || {}));
  });
}

/**
 * 获取用户信息
 * 
 * @export
 * @returns 
 */
export function fetchUserInfo() {
  const options = {
    url: dataAPI.userInfo,
  };

  return fetch(options);
}

/**
 * 获取用户排行榜
 */
export function fetchRanks() {
  const options = {
    url: dataAPI.getRanks,
  };

  return fetch(options);
}
/**
 * 激活老用户资格
 */
export function ActivateOldStatus(){
  const options = {
    url: dataAPI.activateOldStatus,
  };

  return fetch(options);
}


export function confTask3(actId:string){
  const options={ 
    actCode : actId,
    isLogin:true
  }
  return f2eGame.port.task3.conf(options);
}

export function joinAndFinish(actId:string,taskId:string|number,gameId:string,serverId:string,){
  const options={
    actCode:actId,
    taskId:taskId,
    times:1,
    gameId:gameId,
    serverId:serverId
  }
  return f2eGame.port.task3.joinAndFinish(options)
  
}

// 查询老用户
export function searchOldUser(value:string){
  const options={
    data:{word:value},
    url:dataAPI.serchOldUsers
  }
  return fetch(options);
  
}

// // 获取用户当期投票记录

export function getBindUsers(){
  const options={
    url:dataAPI.voteHistory
  }
  return fetch(options);
}

// 绑定好友

export function bindFriend(bindyyuid:string|number){
  const options={
    data:{
      inviter:bindyyuid
    },
    url:dataAPI.bindFriend
  }
  return fetch(options);
}

// 投票

export function voteTicket(){
  const options={
    url:dataAPI.voteTicket
  }
  return fetch(options);
}

// 获取用户昵称

export function fetchNickname(yyuid){
  const options={
    url:dataAPI.getNickname,
    data:{
      yyuid:yyuid
    }
  }
  return fetch(options)
}
// /**
//  * 检索任务
//  *
//  * @export
//  * @param {string} actId
//  * @returns Promise
//  */
// export function fetchTask3(actId: string) {
//   const options = {
//     data: { act: actId },
//     url: dataAPI.task4366,
//   };

//   return fetch(options);
// }


// /**
//  * joinAndFinish
//  * 
//  * @export
//  * @param {*} params 
//  * @returns 
//  */
// export function joinAndFinish(params: any) {
//   const options = {
//     data: params,
//     url: dataAPI.jfinish,
//   };

//   return fetch(options);
// }


// /**
//  * 检索商品
//  * 
//  * @export
//  * @param {*} params 
//  * @returns 
//  */
// export function fetchMall(params: any) {
//   const options = {
//     data: params,
//     url: dataAPI.mallSearch,
//   };

//   return fetch(options);
// }

// /**
//  * 检索兑换记录
//  * 
//  * @export
//  * @param {*} params 
//  * @returns 
//  */
// export function fetchExchangeRecord() {
//   const { mallId } = appState;
//   const options = {
//     data: {
//       mallId,
//       page: 0,
//       pageSize: 10000,
//     },
//     url: dataAPI.exchangeList,
//   };

//   return fetch(options);
// }


// /**
//  * 检索商品详情
//  * 
//  * @export
//  * @param {number} id 
//  * @returns 
//  */
// export function fetchProductDetail(id: number) {
//   const options = {
//     data: {
//       mallGoodsId: id,
//     },
//     url: dataAPI.productDetail,
//   };

//   return fetch(options);
// }


// export function fetchBuyProduct(id: number, realName?: string, phone?: string, address?: string, yyim?: string) {
//   const options = {
//     data: {
//       mallGoodsId: id,
//       realName,
//       phone,
//       address,
//       yyim,
//     },
//     url: dataAPI.buyProduct,
//   };

//   return fetch(options);
// }


// /**
//  * 拉取手机验证码
//  * 
//  * @export
//  * @param {string} phone 
//  * @returns 
//  */
// export function fetchPhoneCode(phone: string) {
//   const options = {
//     data: { mobile: phone },
//     url: dataAPI.sendPhoneCode,
//   };

//   return fetch(options);
// }


// /**
//  * 请求服务器绑定手机
//  * 
//  * @export
//  * @param {string} token 
//  * @param {string} smscode 
//  * @returns 
//  */
// export function requestBindMobile(token: string, smscode: string) {
//   const options = {
//     data: { token, smscode },
//     url: dataAPI.bindMobile,
//   };

//   return fetch(options);
// }




// /**
//  * 拉取邮箱验证码
//  * 
//  * @export
//  * @param {string} email 
//  * @returns 
//  */
// export function fetchEmailCode(email: string) {
//   const options = {
//     data: { email },
//     url: dataAPI.sendEmailCode,
//   };

//   return fetch(options);
// }

// /**
//  * 请求服务器绑定邮箱
//  * 
//  * @export
//  * @param {string} token 
//  * @param {string} emailcode 
//  * @returns 
//  */
// export function requestBindEmail(token: string, emailcode: string) {
//   const options = {
//     data: { token, emailcode },
//     url: dataAPI.bindEmail,
//   };

//   return fetch(options);
// }


// /**
//  * 请求gslist
//  * 
//  * @export
//  * @param {*} params 
//  * @returns 
//  */
// export function fetchGSList(params: string) {
//   const options = {
//     url: `${dataAPI.gslist}?jsonp&online&${params}`,
//     jsonpCallback: 'jsonpcallback',
//   };

//   return fetch(options);
// }

// /**
//  * 拉我的积分
//  * 
//  * @export
//  * @returns 
//  */
// export function fetchMyPoint() {
//   const options = {
//     url: `${dataAPI.myPoint}?prizeId=PRIZE_CENTER-4366JF`,
//   };

//   return fetch(options);
// }

// /**
//  * 拉取我的中奖记录
//  * 
//  * @export
//  * @returns 
//  */
// export function fetchMixPackage() {
//   const {
//     actIdDailyModule,
//     actIdGameModule,
//     actIdLotteryModule,
//     actIdNewModule
//   } = appState;
//   const act = [actIdDailyModule,
//     actIdGameModule,
//     actIdLotteryModule,
//     actIdNewModule].join(',');
//   const options = {
//     url: `${dataAPI.mixPackage}`,
//     data: {
//       act,
//       pageId: 1,
//       pageSize: 10000
//     }
//   };

//   return fetch(options);
// }


// WEBPACK FOOTER //
// ./src/utils/fetch.ts